import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full py-12 px-4 border-t border-border" data-id="element-50">
      <div className="container max-w-6xl mx-auto" data-id="element-51">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-52">
          {/* Brand - using dark logo */}
          <div className="text-center md:text-left" data-id="element-53">
            <div className="w-56 mb-2 mx-auto md:mx-0" data-id="element-54">
              <img src="https://cdn.magicpatterns.com/uploads/3a5J6De2WuRis18d4fBZJq/wisepilot-dark.svg" alt="WisePilot Logo" className="w-full h-auto" data-id="element-55" />
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-56">
              AI-Governed Content Operations
            </p>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-wrap justify-center gap-6 text-sm" aria-label="Footer navigation" data-id="element-57">
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-58">
              Product
            </a>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-59">
              How It Works
            </a>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-60">
              Reports
            </a>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-61">
              Integrations
            </a>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-62">
              Pricing
            </a>
          </nav>

          {/* Legal Links */}
          <div className="flex gap-6 text-sm" data-id="element-63">
            <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-64">
              Privacy
            </Link>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-65">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}